<template>
    <div class="login-form">
      <div class="card">
        <h1>Sign In</h1>
        <button class="google" @click="signInWithGoogle">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" class="abcRioButtonSvg">
            <g>
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
              <path fill="none" d="M0 0h48v48H0z"></path>
            </g>
          </svg>
          <span>Sign in with Google</span>
        </button>
        <button class="twitter" @click="signInWithTwitter">
          <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 400 400">
            <g id="Logo_FIXED" data-name="Logo — FIXED">
              <path class="cls-2" fill="#fff" d="M153.62,301.59c94.34,0,145.94-78.16,145.94-145.94,0-2.22,0-4.43-.15-6.63A104.36,104.36,0,0,0,325,122.47a102.38,102.38,0,0,1-29.46,8.07,51.47,51.47,0,0,0,22.55-28.37,102.79,102.79,0,0,1-32.57,12.45,51.34,51.34,0,0,0-87.41,46.78A145.62,145.62,0,0,1,92.4,107.81a51.33,51.33,0,0,0,15.88,68.47A50.91,50.91,0,0,1,85,169.86c0,.21,0,.43,0,.65a51.31,51.31,0,0,0,41.15,50.28,51.21,51.21,0,0,1-23.16.88,51.35,51.35,0,0,0,47.92,35.62,102.92,102.92,0,0,1-63.7,22A104.41,104.41,0,0,1,75,278.55a145.21,145.21,0,0,0,78.62,23"/>
            </g>
          </svg>
          <span>Sign in with Twitter</span>
        </button>
        <button class="facebook" @click="signInWithFacebook">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="18px" width="18px" viewBox="0 0 455.73 455.73" style="enable-background:new 0 0 455.73 455.73;" xml:space="preserve">
            <path style="fill: #fff;" d="M0,0v455.73h242.704V279.691h-59.33v-71.864h59.33v-60.353c0-43.893,35.582-79.475,79.475-79.475h62.025v64.622h-44.382c-13.947,0-25.254,11.307-25.254,25.254v49.953h68.521l-9.47,71.864h-59.051V455.73H455.73V0H0z"/>
          </svg>
          <span>Sign in with Facebook</span>
        </button>
        <div class="error" v-if="error">
          <p>{{error}}</p>
        </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase'

export default {
  name: 'LoginForm',
  components: {
  },
  data () {
    return {
      user: null,
      error: null
    }
  },
  methods: {
    toggle () {
      this.show = !this.show
    },
    signInWithGoogle () {
      const provider = new firebase.auth.GoogleAuthProvider()
      const self = this

      firebase.auth().signInWithPopup(provider).then((result) => {
        this.user = result.user
      }).catch(function (error) {
        self.error = error.message
      })
    },
    signInWithTwitter () {
      const provider = new firebase.auth.TwitterAuthProvider()
      const self = this

      firebase.auth().signInWithPopup(provider).then((result) => {
        this.user = result.user
      }).catch(function (error) {
        self.error = error.message
      })
    },
    signInWithFacebook () {
      var provider = new firebase.auth.FacebookAuthProvider()
      const self = this

      firebase.auth().signInWithPopup(provider).then((result) => {
        this.user = result.user
        console.log(this.user)
      }).catch(function (error) {
        self.error = error.message
      })
    }
  },
  beforeCreate () {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user

        firebase.database().ref('users/' + user.uid).update({
          displayName: user.displayName,
          email: user.email || user.providerData[0].email,
          emailVerified: user.emailVerified,
          phoneNumber: user.phoneNumber,
          photoURL: user.photoURL,
          providerId: user.providerData[0].providerId
        })

        this.$router.push('/account')
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.card {
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 250px;
  width: 100%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 0 20px;
  color: #212121;
}

h1 {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;
  color: white;
  letter-spacing: 6px;
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 1em;
}

button {
  margin: 20px auto;
  font-family: 'Roboto', Arial, sans-serif;
  position: relative;
  border-radius: 1px;
  display: block;
  border: none;
  width: 100%;
  font-weight: 500;
  font-size: 13px;
  padding: 8px 8px 8px (18px + (8px * 2));
  outline: none;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
  letter-spacing: .21px;
  transition: box-shadow .2s ease-in-out;
  vertical-align: middle;
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 3px 3px rgba(66, 133, 244, .3);
  }

  svg {
    position: absolute;
    top: 50%;
    left: 8px;
    transform: translateY(-50%);
  }
}

.google {
  background: white;
  color: #757575;
}

.twitter {
  background: #00aced;
  color: white;
}

.facebook {
  background: #3b5998;
  color: white;
}

.error {
  color: #E91E63;
  text-align: left;
  font-weight: bold;
  line-height: 1.2
}

</style>



// WEBPACK FOOTER //
// src/components/login-form.vue